import React, { Component } from 'react';
import { setEvent } from '../../services'


import '../../styles/classroom/ClassroomToolBar.css';


export default class ClassroomToolBar extends Component{
    constructor(props) {
        super(props)

        this.state = {
            showNavigation: false,
        }
    }

	onScrollToTopClick(){
		this.context.classroomPage.scrollToTop(true);
		this.context.page.showTips('已到达顶部', 'primary');
		setEvent({ name: 'classroom-click-scroll-to-top' })
	}

	onScrollToBottomClick(){
		this.context.classroomPage.scrollToBottom(true);
		this.context.page.showTips('已到达底部', 'primary');
		setEvent({ name: 'classroom-click-scroll-to-bottom' })
	}

	showNavigation(){
        this.setState({showNavigation: true});

        this.tipsTimer && clearTimeout(this.tipsTimer);
        this.tipsTimer = setTimeout(() => {
            this.setState({showNavigation: false});
        }, 5000);
	}

	componentWillUnmount(){
        this.tipsTimer && clearTimeout(this.tipsTimer);
	}

	render(){
		if(!this.state.showNavigation){
			return null
		}

		return (<div className="classroom-toolbar" style={{...this.props.style}}>
			<div className="navigation">
				<div 
					onClick={this.onScrollToTopClick.bind(this)}>
					<i className="iconfont icon-huidaodingbu" aria-hidden="true"></i>
				</div>
				<div className="dibu"
					onClick={this.onScrollToBottomClick.bind(this)}>
					<i className="iconfont icon-huidaodingbu" aria-hidden="true"></i>
				</div>
			</div>
		</div>)
	}
}


ClassroomToolBar.contextTypes = {
  	classroomPage: React.PropTypes.object,
  	page: React.PropTypes.object
};




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomToolBar.js